(function(){
  var D={};try{D=JSON.parse(document.getElementById('pk-pdp-data').textContent);}catch(e){}
  var V=D.v||{}, single=!!D.single;
  function upd(){
    var s=document.querySelector('.sticky-atc'); if(!s) return;
    var box=s.querySelector('.sticky-atc__left__content'); if(!box) return;
    var q=document.querySelector('input[name="quantity"]:checked');
    var lab=q?document.querySelector('label[for="'+q.id+'"]'):null;
    if(!lab) return;
    var t=lab.querySelector('.quantity-break__label-text'), p=lab.querySelector('.quantity-break__price');
    var name=t?t.textContent.replace(/\s+/g,' ').trim():'', price=p?p.textContent.replace(/\s+/g,' ').trim():'';
    if(!price) return;
    var qty=parseInt(q.value,10)||1;
    var idEl=document.querySelector('#'+(D.form||'x')+' input[name="id"]');
    var vt=(!single&&idEl&&qty===1&&V[idEl.value])?V[idEl.value]:'';
    var el=box.querySelector('.pk-sticky-sel');
    if(!el){el=document.createElement('span');el.className='pk-sticky-sel';box.appendChild(el);}
    var lead=[name,vt].filter(Boolean).join(' · ');
    el.textContent=lead?lead+' · ':'';
    var b=document.createElement('b');b.textContent=price;el.appendChild(b);
    s.classList.add('pk-on');
  }
  document.addEventListener('change',function(){setTimeout(upd,150);});
  document.addEventListener('click',function(e){if(e.target&&e.target.closest&&e.target.closest('.quantity-break')){setTimeout(upd,150);}});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(upd,300);});}else{setTimeout(upd,300);}
})();